import { useTranslation } from "react-i18next";

import View from "components/elements/View";
import {
  Col,
  Row,
  Button,
  notification,
  Form,
  Input,
  Typography,
  Checkbox,
} from "antd";
import { useState } from "react";
import {
  useSendBlOkThNotOkMailsMutation,
  useGetOpenM41MailsQuery,
} from "store/dispatch";

function IncentiveManagement(): JSX.Element {
  const { t } = useTranslation();
  const [sendIncentiveMailForm] = Form.useForm();
  const [sendM41Mails] = useSendBlOkThNotOkMailsMutation();
  const { data, isLoading, refetch } = useGetOpenM41MailsQuery();
  const [isSendingMails, setIsSendingMails] = useState(false);

  const confirmsendM41Mails = async (
    kundennummer: number,
    forceResend: boolean
  ) => {
    try {
      setIsSendingMails(true);
      const response = await sendM41Mails({
        kundennummer,
        forceResend,
      }).unwrap();
      if (!response.hasErrors) {
        notification.success({
          message: t("incentiveManagement.m41Success"),
        });
      } else {
        notification.error({ message: response.errorMessage });
      }
      refetch();
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsSendingMails(false);
    }
  };

  const handleFormSubmit = (values: {
    customerId: number;
    forceResend: boolean;
  }) => {
    confirmsendM41Mails(values.customerId, values.forceResend);
  };

  return (
    <View
      title={t("incentiveManagement.title")}
      isLoading={isLoading || isSendingMails}
    >
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Row>
            <Typography.Title level={5}>
              {t("incentiveManagement.titleM41", {
                amountMails: !data ? 0 : data.total,
                amountOpenMails: !data ? 0 : data.open,
              })}
            </Typography.Title>
            <Typography.Text>
              {t("incentiveManagement.descriptionM41")}
            </Typography.Text>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Form
              id="sendM41Mail"
              form={sendIncentiveMailForm}
              onFinish={handleFormSubmit}
            >
              <Col>
                <Form.Item
                  label={t("incentiveManagement.customerId")}
                  name="customerId"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name="forceResend"
                  valuePropName="checked"
                  label={t("incentiveManagement.forceResend")}
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isSendingMails}
                  block
                >
                  {t("incentiveManagement.sendM41MailsButton")}
                </Button>
              </Col>
            </Form>
          </Row>
        </Col>
      </Row>
    </View>
  );
}

export default IncentiveManagement;
